import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEqual } from 'underscore';
import DataList from 'components/ui/DataList';
import { withTranslation } from 'react-i18next';
import Pane from './Pane';
import ExceptionPaneHeader from './ExceptionPaneHeader';
import ExceptionDetails from './ExceptionDetails';
import ShipmentDetails from './ShipmentDetails';
import Mapping from './Mapping';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import { showToast } from 'stores/ToastStore';
import { getExceptionHighlightClassnames } from '../../../helpers/exceptions';

class ExceptionList extends Component {
  static propTypes = {
    exceptions: PropTypes.array.isRequired,
    page: PropTypes.number,
    perPage: PropTypes.number,
    totalCount: PropTypes.number,
    totalPages: PropTypes.number,
    userType: PropTypes.string,
    onPaginationSelect: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      showPane: false,
      currentException: null,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.currentException && nextProps.exceptions) {
      const exception = nextProps.exceptions.find(
        (e) => e._id === this.state.currentException._id,
      );
      if (exception) {
        if (!isEqual(this.state.currentException, exception)) {
          this.setState({ currentException: exception });
        }
      }
    }
  }

  getSelected() {
    const { currentException } = this.state;

    if (currentException) {
      return [currentException._id];
    }
    return [];
  }

  addCommentToRender(comment) {
    return {author : "Admin Admin", authorType : "Admin", email :  "admin@cargomatic.com", message : comment, read: true, timestamp : new Date().toISOString(), _id : "1" };
  }
  
  handleAddComment = async (comment) => {
    const { t } = this.props;
    try {
      const result = await ShipmentWebAPIUtils.addComment(
        this.state.currentException.shipment._id,
        comment,
      );
      if (result && result.entity && result.entity.success) {
        showToast(t('COMMENT_UPDATED_SUCCESSFULLY'), '', 'success');
        let comments = this.state.currentException.shipment.comments || [];
        comments = [this.addCommentToRender(comment), ...comments];
        const exception = this.state.currentException;
        const shipment = this.state.currentException.shipment;
        shipment.comments = comments;
        exception.shipment = shipment;
        this.setState({
          currentException: exception,
        });
      }
    } catch (e) {
      console.error(e);
      showToast(
        t('COMMENT_UPDATE_FAILED'),
        t('COULDNT_UPDATE_COMMENT', { message: e.message }),
        'error',
      );
    }
  };

  handleExceptionClick(exception) {
    const update = {
      currentException: exception,
      showPane: !this.state.showPane,
    };

    if (this.state.showPane) {
      delete update.showPane;
    }

    this.setState(update);
  }

  closePane() {
    this.setState({
      currentException: null,
      showPane: false,
    });
  }

  mapColumnHeaders = (columns) => {
    const { t } = this.props;
    return columns.map((column) => {
      return {
        ...column,
        headerText: t(column.localizationSlug),
      };
    });
  };

  shouldRowHighlight = (row) => {
    return getExceptionHighlightClassnames(row);
  };

  render() {
    let pane;

    if (this.state.currentException) {
      pane = (
        <Pane
          show={this.state.showPane}
          header={
            <ExceptionPaneHeader
              exception={this.state.currentException}
              closePane={() => this.closePane()}
            />
          }
          body={[
            <ExceptionDetails
              exception={this.state.currentException}
              key={0}
            />,
            <ShipmentDetails
              onChange={(exception) =>
                this.setState({ currentException: exception })
              }
              onAddComment={this.handleAddComment}
              exception={this.state.currentException}
              shipment={this.state.currentException.shipment}
              userType={this.props.userType}
              key={1}
              onInitiateResolution={this.props.onInitiateResolution}
            />,
          ]}
        />
      );
    }

    const tableWrapperClassName = classnames({
      'md:w-2/3': this.state.showPane,
      'w-full': true,
    });

    return (
      <div className="flex flex-wrap">
        <div className={tableWrapperClassName}>
          <DataList
            shouldRowHighlight={this.shouldRowHighlight}
            clickToSelect
            select
            selected={this.getSelected()}
            condensed
            hideSelectColumn
            showHeaders
            paginate
            onSelect={(exception) => this.handleExceptionClick(exception)}
            data={this.props.exceptions}
            columns={this.mapColumnHeaders(Mapping.columns)}
            total={this.props.totalCount}
            pages={this.props.totalPages}
            page={this.props.page}
            perPage={this.props.perPage}
            onPaginationSelect={(page) => this.props.onPaginationSelect(page)}
            hiddenColumns={['severity']}
          />
        </div>
        <div className="md:w-1/3 w-full">{pane}</div>
      </div>
    );
  }
}

ExceptionList.propTypes = {
  onInitiateResolution: PropTypes.func.isRequired,
};

export default withTranslation()(ExceptionList);
